import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function CostComparison() {
  const comparisonRows = [{
    sin: 'Noches en vela',
    perdes: 'Buscando cómo traducir conceptos técnicos del agro a un lenguaje que tus alumnos puedan entender en el aula'
  }, {
    sin: 'Clases improvisadas',
    perdes: 'Porque no encontraste un material claro y listo para usar a tiempo'
  }, {
    sin: 'Alumnos desconectados',
    perdes: 'Que sienten que la producción agropecuaria no tiene nada que ver con ellos ni con su futuro laboral'
  }, {
    sin: 'Silencios incómodos',
    perdes: 'Cuando un alumno pregunta la diferencia entre un sistema de riego por goteo y uno por aspersión y no tenés una respuesta clara a mano'
  }, {
    sin: 'Fines de semana perdidos',
    perdes: 'Armando planificaciones, actividades y evaluaciones desde cero una y otra vez'
  }];
  return <section className="py-20 bg-[#1a3622] text-white" data-id="element-18">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-[#d4af37]" data-id="element-21">
            ⚠️ EL COSTO DE NO TENER EL MATERIAL CORRECTO
          </h2>
        </div>

        <div className="bg-[#122618]/60 rounded-2xl p-6 md:p-10 border border-[#2c4c3b] mb-12 max-w-3xl mx-auto" data-id="element-22">
          <ul className="space-y-6" data-id="element-23">
            {comparisonRows.map((row, i) => <li key={i} className="grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-4 items-start" data-id="element-24">
                <div className="flex items-start gap-3" data-id="element-25">
                  <div className="mt-1 bg-[#2c4c3b] p-1 rounded-full shrink-0 border border-[#d4af37]/50" data-id="element-26">
                    <X className="w-4 h-4 text-[#d4af37]" data-id="element-27" />
                  </div>
                  <span className="text-[#fdfbf7] font-bold text-sm md:text-base" data-id="element-28">
                    {row.sin}
                  </span>
                </div>
                <div className="text-[#cbd5e1] text-sm md:text-base" data-id="element-29">
                  {row.perdes}
                </div>
              </li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-[#2c4c3b] to-[#122618] rounded-2xl p-8 md:p-12 shadow-2xl border border-[#d4af37]/30" data-id="element-30">
          <p className="md:text-3xl font-black text-white text-[20px] mb-6" data-id="element-31">
            Basta de regalar tu tiempo libre. Tu dedicación ya la tenés. Ahora
            te falta la herramienta.
          </p>
        </motion.div>
      </div>
    </section>;
}